import { PropsWithChildren } from 'react';
import { GenericErrorComponent } from '../generic-error';

interface ErrorOrChildrenComponentProps extends PropsWithChildren {
  isError?: boolean;
}

export const ErrorOrChildren: React.FC<ErrorOrChildrenComponentProps> = props => {
  const { isError, children } = props;

  return isError ? <GenericErrorComponent /> : <>{children}</>;
};
